"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Types = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Button = _interopRequireDefault(require("../../../Button"));
var _dialer = require("../../../../icons-react/dialer");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Types = exports.Types = {
  START_CALL: 'start_call',
  END_CALL: 'end_call',
  HOLD: 'hold',
  MIC: 'mic',
  ANONIMIZER: 'anonimizer',
  HELPER: 'helper',
  SUPERVISOR: 'supervisor',
  WITHDRAW: 'withdraw'
};
var RoundButton = /*#__PURE__*/function (_React$PureComponent) {
  function RoundButton() {
    (0, _classCallCheck2["default"])(this, RoundButton);
    return _callSuper(this, RoundButton, arguments);
  }
  (0, _inherits2["default"])(RoundButton, _React$PureComponent);
  return (0, _createClass2["default"])(RoundButton, [{
    key: "render",
    value: function render() {
      var actionType = this.props.actionType;
      return /*#__PURE__*/_react["default"].createElement(StyledRoundButton, this.props, RoundButton.icon(actionType));
    }
  }], [{
    key: "icon",
    value: function icon(type) {
      switch (type) {
        case Types.START_CALL:
          return /*#__PURE__*/_react["default"].createElement(_dialer.StartCall, null);
        case Types.END_CALL:
          return /*#__PURE__*/_react["default"].createElement(_dialer.StartCall, null);
        case Types.HOLD:
          return /*#__PURE__*/_react["default"].createElement(StyledHoldIcon, null);
        case Types.MIC:
          return /*#__PURE__*/_react["default"].createElement(_dialer.Mic, null);
        case Types.ANONIMIZER:
          return /*#__PURE__*/_react["default"].createElement(_dialer.Anonimizer, null);
        case Types.HELPER:
          return /*#__PURE__*/_react["default"].createElement(_dialer.Help, null);
        case Types.SUPERVISOR:
          return /*#__PURE__*/_react["default"].createElement(_dialer.Supervisor, null);
        case Types.WITHDRAW:
          return /*#__PURE__*/_react["default"].createElement(_dialer.Withdraw, null);
        default:
          return null;
      }
    }
  }]);
}(_react["default"].PureComponent);
RoundButton.propTypes = {
  className: _propTypes["default"].string,
  actionType: _propTypes["default"].oneOf(Object.values(Types)),
  active: _propTypes["default"].bool,
  pulsing: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func
};
RoundButton.defaultProps = {
  className: '',
  actionType: null,
  active: false,
  pulsing: false,
  disabled: false,
  onClick: Function.prototype
};
RoundButton.Types = Types;
var StyledHoldIcon = _styledComponents["default"].div.withConfig({
  displayName: "RoundButton__StyledHoldIcon",
  componentId: "sc-yzy5w9-0"
})(["&:before,&:after{top:10px;left:14px;width:1px;content:'';height:19px;position:absolute;background-color:#fff;}&:after{margin-left:8px;}"]);
var StyledRoundButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "RoundButton__StyledRoundButton",
  componentId: "sc-yzy5w9-1"
})(["width:40px;height:40px;display:flex;overflow:visible;position:relative;border-radius:100%;align-items:center;justify-content:center;border:1px solid white;background-color:#262729;&:hover{border-color:white;}> svg{width:20px;}", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", ""], function (_ref) {
  var actionType = _ref.actionType;
  return actionType === Types.START_CALL && "\n    background-image: linear-gradient(to bottom, #00e04b, #00b0b6);\n  ";
}, function (_ref2) {
  var actionType = _ref2.actionType;
  return actionType === Types.END_CALL && "\n    background-image: linear-gradient(to bottom, #ff860c, #e5200e);\n    \n    > svg {\n      transform: rotate(-136deg);\n    }\n  ";
}, function (_ref3) {
  var actionType = _ref3.actionType;
  return [Types.ANONIMIZER, Types.SUPERVISOR].includes(actionType) && "\n    margin-top: 1px;\n  ";
}, function (_ref4) {
  var actionType = _ref4.actionType,
    active = _ref4.active;
  return [Types.HELPER, Types.ANONIMIZER, Types.SUPERVISOR, Types.WITHDRAW].includes(actionType) && "\n    svg {\n      z-index: 2;\n      transform: scale(1.2);\n      path:nth-child(1) { stroke: ".concat(active ? 'black' : 'white', "; }\n      path:nth-child(2) { fill: ").concat(active ? 'black' : 'white', "; }\n    }\n  ");
}, function (_ref5) {
  var actionType = _ref5.actionType,
    active = _ref5.active;
  return actionType === Types.HELPER && !active && "\n    svg {\n      path, circle { stroke: white; }\n    }\n  ";
}, function (_ref6) {
  var actionType = _ref6.actionType,
    active = _ref6.active;
  return [Types.MIC, Types.SUPERVISOR].includes(actionType) && active && "\n    &:before {\n      top: 18px;\n      left: 5px;\n      height: 1px;\n      content: '';\n      width: 27px;\n      background: #000;\n      position: absolute;\n      transform: rotate(38deg);\n    }\n  ";
}, function (_ref7) {
  var actionType = _ref7.actionType,
    active = _ref7.active;
  return actionType === Types.MIC && active && "\n    svg { rect, path { stroke: black; } }\n  ";
}, function (_ref8) {
  var actionType = _ref8.actionType,
    active = _ref8.active;
  return actionType === Types.HOLD && active && "\n    div {\n      &:before,\n      &:after { background: black; }\n    }\n  ";
}, function (_ref9) {
  var active = _ref9.active;
  return active && "\n    background-color: white;\n  ";
}, function (_ref10) {
  var disabled = _ref10.disabled;
  return disabled && "\n    opacity: 0.5;\n  ";
}, function (_ref11) {
  var pulsing = _ref11.pulsing;
  return pulsing && "\n    overflow: visible;\n    background-color: transparent;\n    border-color: rgba(255,255,255,.4);\n\n    &:before,\n    &:after {\n      top: 50%;\n      left: 50%;\n      content: '';\n      z-index: 1;\n      opacity: 0.5;\n      position: absolute;\n      border-radius: 100%;\n      animation: pulsing 1.5s infinite ease-in-out;\n      background-image: linear-gradient(to top, #00e04b, #00b0b6);\n    }\n\n    &:before {\n      width: 78px;\n      height: 78px;\n      margin-top: -39px;\n      margin-left: -39px;\n    }\n\n    &:after {\n      width: 112px;\n      height: 112px;\n      margin-top: -56px;\n      margin-left: -56px;\n    }\n\n    @keyframes pulsing {\n      from {transform: scale(.5);}\n    }\n  ";
});
var _default = exports["default"] = RoundButton;